<template lang="html">
  <div id="landingPage" class="row">
    <!-- <b-row id="row1" > -->
      <b-col lg="2" class=""></b-col>
      <b-col lg="4" id="buttonLeft">
        <span  @click="buttonClicked(1)">
          <b-img id="bigButton1" src="img/JBR Button 1.svg"></b-img>
        </span>
      </b-col>
      <b-col lg="4" id="labelRight">
        <span>
          <b-img id="label1" src="img/JBR Contact button.svg"></b-img>
        </span>
      </b-col>
      <!-- <b-col lg="4" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(2)"><b-img fluid src="img/ESK.png"></b-img></b-button></b-col> -->
      <!-- <b-col lg="4" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(3)"><b-img fluid src="img/PYM.png"></b-img></b-button></b-col>
    </b-row>
    <b-row id="row2">
      <b-col lg="6" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(4)"><b-img fluid src="img/THN.png"></b-img></b-button></b-col>
      <b-col lg="6" class=""><b-button class="bigButton" size="lg" @click="buttonClicked(5)"><b-img fluid src="img/NMH.png"></b-img></b-button></b-col> -->
    <!-- </b-row> -->
    <!-- <div class="row" id="row1">
      <div class="col-1">

      </div>
      <div class="col-3">
        ts
      </div>
      <div class="col-3">
        st
      </div>
      <div class="col-3">

      </div>
      <div class="col-1">

      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "LandingPage",
  methods: {
    buttonClicked: function(id) {
      // console.log(id);
      // console.log(this.$router);
      this.$router.push({ name: 'MainApp', params: { activeTab: id } })
    }
  }
}
</script>

<style>
  #landingPage {
    width: 100vw;
    height: 87vh;
  }
  #buttonLeft {
    padding-top: 27vh;
    height: 43vh;
  }
  #labelRight {
    padding-top: 20vh;
    height: 43vh;
  }
  /* #button2 {
    padding-top: 20vh;
    height: vh;
  } */
  #bigButton1 {
    height: 30vh!important;
  }
  #label1 {
    height: 45vh!important;
  }
  #bigButton1:hover, #bigButton1:active {
    /* background: rgba(128, 128, 128, 0.5)!important; */
    transform: scale(1.01);
    cursor: pointer;
  }
</style>
